module.exports = __webpack_public_path__ + "static/media/csv-users.91c535e6.svg";